import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { SHOW_HIDE_ANIMATION_DURATION } from './Toast.constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var StyledToast = styled.dialog(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: ", ";\n  background-color: ", ";\n  border-top: ", ";\n  border-bottom: ", ";\n  //  The left and right borders are created by adding 2px left and right padding to the ToastContainer.\n  color: ", ";\n  padding: 0;\n  max-width: 30rem;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0px;\n    height: ", ";\n    background-color: ", ";\n    animation: countdown ", "ms linear forwards;\n  }\n\n  &:hover::after {\n    animation-play-state: paused;\n  }\n\n  &:focus::after {\n    animation-play-state: paused;\n  }\n\n  &[open] {\n    animation: show ", "ms;\n\n    &.close-toast {\n      animation: hide ", "ms;\n    }\n  }\n\n  @keyframes countdown {\n    from {\n      width: 0%;\n    }\n    to {\n      width: 100%;\n    }\n  }\n\n  @keyframes show {\n    from {\n      opacity: 0;\n      transform: translateY(min(100px, 5vh));\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n  }\n\n  @keyframes hide {\n    from {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n    to {\n      opacity: 0;\n      transform: translateY(min(100px, 5vh));\n    }\n  }\n\n  &::backdrop {\n    display: none;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.sizing.medium;
}, function (_ref2) {
  var theme = _ref2.theme,
    $type = _ref2.$type;
  return theme.colours.messaging[$type].main;
}, function (_ref3) {
  var theme = _ref3.theme,
    $type = _ref3.$type;
  return "".concat(theme.sizing.xtiny, " solid\n     ").concat(theme.colours.messaging[$type].main);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.sizing.xtiny, " solid\n     ").concat(theme.colours.canvas.primary.main);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colours.ink.primary.main;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.sizing.xtiny;
}, function (_ref7) {
  var theme = _ref7.theme,
    $type = _ref7.$type;
  return theme.colours.messaging[$type].main;
}, function (_ref8) {
  var $timer = _ref8.$timer;
  return $timer;
}, SHOW_HIDE_ANIMATION_DURATION, SHOW_HIDE_ANIMATION_DURATION);
var ToastContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  padding-block: 0;\n  padding-inline: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.xtiny;
});
var IconContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding-block: 0;\n  padding-inline: ", ";\n  svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return "".concat(theme.sizing.tiny, " ").concat(theme.sizing.xtiny);
}, function (_ref11) {
  var theme = _ref11.theme,
    $type = _ref11.$type;
  return theme.colours.messaging[$type].ink;
});
var ToastContent = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: grid;\n  padding-block: ", ";\n  padding-inline: ", ";\n  background-color: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.sizing.small;
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.sizing.small, " 1.75rem");
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colours.canvas.tertiary.main;
});
var CloseButtonContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n"])), function (_ref15) {
  var theme = _ref15.theme,
    $hasTitle = _ref15.$hasTitle;
  return $hasTitle ? theme.sizing.tiny : 'unset';
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.sizing.tiny;
});
var Title = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  grid-row: 1;\n"])));
var Content = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  grid-row: 2;\n  grid-column: 1 / -1;\n  display: flex;\n  gap: ", ";\n  align-items: center;\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.sizing.small;
});

export { CloseButtonContainer, Content, IconContainer, StyledToast, Title, ToastContainer, ToastContent };
//# sourceMappingURL=Toast.styles.js.map
